<template>
  <el-card shadow="always">
    <div>
      <el-form ref="form" :model="importForm" label-width="120px">
        <LayoutList ref="layoutList" v-on:apply="apply" :type="type" />
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
            <el-form-item :label="$t('formato')" prop="format">
              <el-radio-group v-model="importForm.format" size="small">
                <el-radio-button value="1" label="CSV"></el-radio-button>
                <el-radio-button value="2" label="TXT"></el-radio-button>
                <el-radio-button value="3" label="XLS"></el-radio-button>
                <el-radio-button value="4" label="HTML"></el-radio-button>
                <el-radio-button value="5" label="XML"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5" v-show="importForm.format != 'XML'">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6"
            v-show="importForm.format == 'CSV' || importForm.format == 'TXT'">
            <el-form-item :label="$t('usar')" prop="use">
              <el-select ref="user" v-model="importForm.use" :disabled="importForm.format == 'CSV'"
                placeholder="Selecione  uma opção">
                <el-option key="1" label="Separador" value="1"></el-option>
                <el-option key="2" label="Tamanho Fixo" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="10" :sm="7" :md="6" :lg="5" :xl="3" v-show="importForm.use == '1' &&
            (importForm.format == 'CSV' || importForm.format == 'TXT')
            ">
            <el-form-item :label="$t('caracter')" prop="separator">
              <el-input v-model="importForm.separator" maxlength="1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="5" :md="5" :lg="5" :xl="5">
            <el-form-item label="" prop="header">
              <el-checkbox v-model="importForm.header">Inserir cabeçalho</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <TransferList ref="transferList" :tableData="tableData" :layout="layout" :type="type" :fields="fields"
        v-on:save="saved" />
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="4" :offset="16">
          <el-button type="primary" @click="doexport()">Exportar</el-button>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { ExportService } from "@/services/customers/export.services";
import moment from "moment";
import "moment/locale/pt-br";
import uuid from "uuid";
import LayoutList from './components/LayoutList.vue';
import TransferList from './components/TransferList.vue';

export default {
  components: { LayoutList, TransferList },
  name: "ExportSender",
  props: ["type", "tableData", "customer", "services", "range"],
  methods: {
    apply(layout, fields) {
      const vm = this;
      vm.layout = layout;
      vm.$refs.transferList.apply(fields);
    },
    saved() {
      this.$refs.layoutList.fetch();
    },
    doexport() {
      const vm = this;
      var fields = vm.$refs.transferList.get();
      if (fields.length == 0) {
        this.$message({
          type: "error",
          message: "Selecione ao menos um campo para exportar",
        });
        return false;
      }
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.range[0]);
      const f = moment(vm.range[1]);
      ExportService.export(
        vm.type,
        fields,
        vm.importForm.format,
        vm.importForm.use,
        vm.importForm.separator,
        vm.importForm.header,
        vm.customer,
        vm.services,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
      )
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${uuid.v4()}.${vm.importForm.format}`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.$message({
            type: "success",
            message: "Arquivo gerado com sucesso!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  data() {
    return {
      layout: '',
      list: [],
      fields: [],
      importForm: {
        use: "1",
        department: "",
        format: "CSV",
        separator: ";",
        header: false,
      },
      filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      value: [],
    };
  },
};
</script>
